import type { IconSvgObject } from './types';

const MarsStrokeIcon: IconSvgObject = [
  ["path", { d: "M20.4961 3.5L13.4961 10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.6642 9C20.6642 9 21.411 4.07875 20.6642 3.33192C19.9173 2.58509 14.9961 3.33194 14.9961 3.33194", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.9961 5.5L18.4961 11", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2.99609 15C2.99609 11.6863 5.68239 9 8.99609 9C12.3098 9 14.9961 11.6863 14.9961 15C14.9961 18.3137 12.3098 21 8.99609 21C5.68239 21 2.99609 18.3137 2.99609 15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MarsStrokeIcon;
